module.exports = __webpack_public_path__ + "static/servicios-creados-para-ti-f4aff46eda529d71dcbc0df7fcbdc7ed.jpg";